import { Link } from "react-router-dom";
import { Reveal, Overline } from "../components/Reveal";

const GRADES = [
  {
    grade: "A", title: "Like New / Excellent",
    img: "https://images.unsplash.com/photo-1551028719-00167b16eac5?q=85&w=900&auto=format&fit=crop",
    points: ["No visible flaws, stains or structural wear", "Fabric, colour and shape fully intact", "Hardware, zips and buttons all original and working", "Often worn only a handful of times"],
  },
  {
    grade: "B", title: "Very Good",
    img: "https://images.unsplash.com/photo-1542272604-787c3835535d?q=85&w=900&auto=format&fit=crop",
    points: ["Light signs of wear — minor fading or pilling", "No stains, tears or repairs needed", "Fully wearable as received", "Honestly photographed, imperfections disclosed"],
  },
  {
    grade: "C", title: "Good",
    img: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?q=85&w=900&auto=format&fit=crop",
    points: ["Clearly worn but well cared for", "Small, disclosed imperfections", "Priced accordingly — strong value", "Still passes the JIGEL resale standard"],
  },
];

export default function GradeGuide() {
  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="grade-guide-page">
      <Reveal className="text-center max-w-2xl mx-auto">
        <Overline>How We Grade</Overline>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-4">The JIGEL Grade.</h1>
        <p className="mt-6 text-ink/60 leading-relaxed">
          Every pre-owned piece is physically inspected before listing. We grade condition honestly — A, B or C — so you always know exactly what you're buying. Items that don't meet Grade C never enter our catalog.
        </p>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-5">
        {GRADES.map((g, i) => (
          <Reveal key={g.grade} delay={i * 0.12} className="border border-border bg-ivory" >
            <div className="aspect-[4/3] overflow-hidden bg-sand">
              <img src={g.img} alt={`Grade ${g.grade} example`} loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="p-7">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 bg-wine text-ivory flex items-center justify-center font-serif text-2xl" data-testid={`grade-${g.grade}`}>{g.grade}</span>
                <p className="font-serif text-2xl">{g.title}</p>
              </div>
              <ul className="mt-5 space-y-2.5">
                {g.points.map((pt) => (
                  <li key={pt} className="text-sm text-ink/60 leading-relaxed flex gap-2"><span className="text-gold">·</span>{pt}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 border border-gold/50 bg-gold/5 p-8 md:p-10 max-w-3xl mx-auto text-center">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Our Standard</p>
        <p className="mt-4 font-serif text-2xl leading-snug">Not every item we receive becomes a JIGEL product. Only items that meet our resale standards are offered to another customer.</p>
        <Link to="/pre-loved" data-testid="grade-guide-shop"
          className="inline-block mt-8 bg-ink text-ivory px-8 py-4 text-[11px] tracking-[0.25em] uppercase hover:bg-wine transition-colors">Shop Graded Pre-Owned</Link>
      </Reveal>
    </div>
  );
}
